var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarMisGrupos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sidebar_mis_grupos",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.693,
    height: 32.693,
    viewBox: "0 0 32.693 32.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M0,0H32.693V32.693H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M15.622,14.26a6.811,6.811,0,0,1,6.811,6.811v8.173H19.709V21.071a4.087,4.087,0,0,0-3.847-4.08l-.24-.007a4.087,4.087,0,0,0-4.08,3.847l-.007.24v8.173H8.811V21.071a6.811,6.811,0,0,1,6.811-6.811ZM6.768,18.346a4.824,4.824,0,0,1,1.1.128,8.1,8.1,0,0,0-.41,2.145l-.012.451v.117a2.032,2.032,0,0,0-.485-.109l-.2-.008a2.043,2.043,0,0,0-2.034,1.847l-.01.2v6.13H2v-6.13a4.768,4.768,0,0,1,4.768-4.768Zm17.709,0a4.768,4.768,0,0,1,4.768,4.768v6.13H26.52v-6.13a2.043,2.043,0,0,0-1.847-2.034l-.2-.01a2.055,2.055,0,0,0-.681.116v-.116a8.124,8.124,0,0,0-.421-2.594A4.658,4.658,0,0,1,24.476,18.346ZM6.768,10.173a3.405,3.405,0,1,1-3.405,3.405,3.405,3.405,0,0,1,3.405-3.405Zm17.709,0a3.405,3.405,0,1,1-3.405,3.405,3.405,3.405,0,0,1,3.405-3.405ZM6.768,12.9a.681.681,0,1,0,.681.681A.681.681,0,0,0,6.768,12.9Zm17.709,0a.681.681,0,1,0,.681.681A.681.681,0,0,0,24.476,12.9ZM15.622,2a5.449,5.449,0,1,1-5.449,5.449A5.449,5.449,0,0,1,15.622,2Zm0,2.724a2.724,2.724,0,1,0,2.724,2.724A2.724,2.724,0,0,0,15.622,4.724Z",
    transform: "translate(0.724 0.724)",
    fill: "#efefef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMisGrupos);
export default __webpack_public_path__ + "static/media/sidebar_mis_grupos.f6dd16d855ac5f047547ed0b46f53682.svg";
export { ForwardRef as ReactComponent };